import React from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next'
import { useSelector } from "react-redux";
import { useMediaQuery } from 'react-responsive'
import ProductCountries from '../../Components/Header/ProductCountries';
import formatPrice from '../../Components/formatPrice';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import GradeIcon from '@mui/icons-material/Grade';
import Skeleton from '@material-ui/lab/Skeleton';
var moment = require('moment');


function ApisSearchResults({ getProducts, userData, isFetching }) {
  const { languageCode } = useSelector((state) => state.auth);
  const { t } = useTranslation()
  const isMobcreen = useMediaQuery({ query: '(min-width: 0px) and (max-width: 768px)' })

  function getDeliverydays(delivery) {
    const deliveryDaya = Number(delivery) + Number(userData?.contant?.delivery_days || 0)
    function getTimeline() {
      if (Number(deliveryDaya) === 1) {
        return <>{t('delivery_by')} <strong>Tomorrow</strong> {moment().add(Number(deliveryDaya), 'days').format('Do')}</>
      } else {
        return <>{t('delivery_by')} {moment().add(Number(deliveryDaya), 'days').format('Do MMM')}</>
      }
    }
    if (Number(deliveryDaya) > 0) {
      return getTimeline()
    } else {
      return `${t('delivery_by')} ${moment().add(10, 'days').format('Do MMM')}`
    }
  }

  function productTitle(title) {
    return title?.replace(/[^A-Za-z0-9]/g, ' ')?.replace(/[^\w\s]/gi, ' ')?.replace(/ /g, '-')
  }

  const handleError = (e) => {
    console.error('Error loading image:', e.target.src);
    e.target.src = 'https://cdn.ebtida.com/1705315901965-Image-not-found.jpg';
  };

  const beforeLoadHandler = () => (
    <img
      className="img-item"
      src='https://cdn.ebtida.com/1705315901965-Image-not-found.jpg' />
  );

  function ratingFucn(rating) {
    if (rating === 0) {
      return false
    } else if (rating === '0') {
      return false
    } else if (!rating) {
      return false
    } else {
      return true
    }
  }

  const soteIds = [3, 1]
  function functionIdLink(id, pid, store_id) {
    if (soteIds?.includes(Number(store_id))) {
      return pid
    } else {
      return id
    }
  }

 
  function checkIfAnyNumber(badge) {
    return /\d|×/.test(badge)
  }

  function removeDuplicates(inputString) {
    const lowerInput = inputString?.toLowerCase();
    if (lowerInput?.includes('prime') || lowerInput?.includes('amazon')) {
      return false;
    }
    const wordsArray = inputString?.split(/\s+/);
    const uniqueWords = [...new Set(wordsArray)];
    const result = uniqueWords?.join(' ');
    return result;
  }

  return (
    <>
      {getProducts?.map((item, i) => item?.pid ?
        <div className="col-md-3 cardItem" style={{ padding: '5px' }} key={i}>
          <Link
            style={{ position: 'relative' }}
            className="cardItem-item"
            to={`/${languageCode}/product/${item?.store_id}/${functionIdLink(item?.id, item?.pid, item?.store_id)}/${productTitle(item?.title)}?country=${item?.country}`}>

            {checkIfAnyNumber(item?.deal_badge) ? '' :
              removeDuplicates(item?.deal_badge) &&
              <div className='deal--badge--'>
                {removeDuplicates(item?.deal_badge)}
              </div>
            }
            <div className="img-card imgCard">
              <LazyLoadImage
                delayTime={100}
                key={i}
                alt={item?.title}
                effect="blur"
                className="img-item"
                src={item?.image}
                onError={handleError}
                beforeLoad={beforeLoadHandler}
              />

              <div className={`delivery-days`}>
                <span style={{ padding: 0 }} className={isMobcreen ? `badge badge-secondary` : ``}>
                  {getDeliverydays(item.estimated_delivery)}
                </span>
              </div>

            </div>
            <div className="card-content">
              <div className='title-card' style={{ maxHeight: '45px', minHeight: '45px' }}>
                <h4>{item?.title?.replace(/[^\w\s.,'/:]/gi, ' ')}</h4>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', lineHeight: 1 }}>
                {item?.brand && <div className='brand' style={{ width: '100%' }}>{item?.brand}</div>}
                {ratingFucn(item?.rating) &&
                  <div className='rating' style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '100%' }}>
                    <span style={{ display: 'flex', alignItems: 'center', color: '#575959', margin: '0px 3px', fontSize: '14px' }}>{item?.rating}</span>
                    <GradeIcon style={{ color: '#fe7f4a', fontSize: '1rem', marginTop: '-1.5px' }} />
                  </div>
                }
              </div>
              <div className="content-item" style={{ padding: 0 }}>
                {isFetching ? <Skeleton className='skeleton' variant="rect" style={{ height: '12px', width: '30%' }} /> :
                  <div className='item-price-card' style={{ alignItems: 'flex-end' }}>
                    {Number(item?.prices?.value) === 0 ?
                      <span className='badge badge-secondary'>Check Price</span>
                      :
                      <>
                        {item?.in_stock ?
                          <>
                            <span className='item-deal-price'>
                              <div style={{ lineHeight: 1.2 }}>
                                <span style={{ fontSize: '12px', fontWeight: 300, color: '#575959' }}>Est. Price</span><br />
                                {formatPrice(item?.prices?.value, item?.prices?.currency, 0)}&nbsp;
                              </div>
                            </span>
                            {item?.prices?.deal_value &&
                              <span className='item-price' style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                                <small style={{ textDecoration: 'line-through', color: '#828282' }}>
                                  {formatPrice(item?.prices?.price, item?.prices?.currency, 0)}
                                </small>&nbsp;
                                {item?.prices?.discount ?
                                  <span className='badge badge-danger'>
                                    {`-${item?.prices?.discount}%`}
                                  </span> : ``
                                }
                              </span>
                            }
                          </> : ''
                        }
                      </>
                    }
                  </div>
                }
              </div>
              <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                <span style={{ fontSize: '11px', fontWeight: 400, color: '#575959' }}>{`(Check Final Price)`}</span>
                {isFetching ? <Skeleton className='skeleton' variant="rect" style={{ height: '12px', width: '30%' }} /> :
                  <div style={{ display: 'flex', alignItems: 'center', fontSize: '12px', lineHeight: 0, color: '#575959' }}>
                    {t('From')}&nbsp;
                    <img
                      style={{ width: '20px', objectFit: 'contain' }}
                      loading="lazy"
                      src={`https://flagcdn.com/w20/${item?.country?.toLowerCase()}.png`}
                      srcSet={`https://flagcdn.com/w40/${item?.country?.toLowerCase()}.png 2x`}
                      alt=""
                    />&nbsp;
                    <div style={{ fontSize: '12px', lineHeight: 0, color: '#575959' }}>{ProductCountries(item?.country)}</div>
                  </div>
                }
              </div>
            </div>
          </Link>
        </div> : ''
      )}
    </>
  )

};

export default ApisSearchResults;